// src/components/Settings.js
import React, { useState } from "react";
import { Users, Trash2 } from "lucide-react";
import {
  collection,
  setDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const SettingsComponent = ({ allowedUsers, user, db, appId, IS_TEST_MODE }) => {
  const [newUserEmail, setNewUserEmail] = useState("");

  const handleAddUser = async () => {
    if (!IS_TEST_MODE && db && newUserEmail) {
      const email = newUserEmail.trim();
      if (!email) return;

      try {
        // 修改：使用 setDoc 並將 email 作為文件 ID，以便設定安全規則
        await setDoc(
          doc(db, "artifacts", appId, "public", "data", "allowed_users", email),
          { email: email, role: "user" }
        );
        setNewUserEmail("");
      } catch (error) {
        console.error("Add user error:", error);
        alert("新增使用者失敗，請確認您擁有管理員權限。");
      }
    }
  };

  const handleRemoveUser = async (id) => {
    if (!IS_TEST_MODE && db && confirm("確定要刪除此使用者?")) {
      try {
        await deleteDoc(
          doc(db, "artifacts", appId, "public", "data", "allowed_users", id)
        );
      } catch (error) {
        console.error("Remove user error:", error);
        alert("刪除失敗");
      }
    }
  };

  const handleUpdateUserRole = async (id, role) => {
    if (!IS_TEST_MODE && db) {
      try {
        await updateDoc(
          doc(db, "artifacts", appId, "public", "data", "allowed_users", id),
          { role }
        );
      } catch (error) {
        console.error("Update role error:", error);
        alert("權限更新失敗");
      }
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
      <div className="p-6 border-b border-slate-100">
        <h2 className="text-lg font-semibold text-slate-700">系統權限設定</h2>
      </div>
      <div className="p-6">
        <h3 className="font-bold text-slate-800 mb-4 flex items-center gap-2">
          <Users size={20} /> 使用者帳號與權限管理
        </h3>
        <div className="flex gap-2 mb-4">
          <input
            type="email"
            placeholder="輸入 Google Email"
            value={newUserEmail}
            onChange={(e) => setNewUserEmail(e.target.value)}
            className="flex-1 p-2 border border-slate-200 rounded-lg outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all"
          />
          <button
            onClick={handleAddUser}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-700 transition-colors"
          >
            新增使用者
          </button>
        </div>
        <div className="space-y-2">
          {allowedUsers.map((u) => (
            <div
              key={u.id}
              className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100 hover:border-slate-200 transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="font-medium text-slate-700">{u.email}</span>
                <select
                  value={u.role}
                  onChange={(e) => handleUpdateUserRole(u.id, e.target.value)}
                  className="text-xs bg-white border border-slate-200 rounded px-2 py-1 outline-none focus:border-blue-400"
                  // 防止刪除自己的管理權限後無法操作，這只是一個簡單的防呆
                  disabled={u.email === user?.email}
                >
                  <option value="user">一般人員</option>
                  <option value="admin">管理員</option>
                </select>
              </div>
              {/* 防止刪除自己 */}
              {u.email !== user?.email && (
                <button
                  onClick={() => handleRemoveUser(u.id)}
                  className="text-red-400 hover:bg-red-50 hover:text-red-500 p-2 rounded-lg transition-colors"
                  title="刪除"
                >
                  <Trash2 size={16} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsComponent;